import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=461f8b33&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=461f8b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f8b33",
  null
  
)

export default component.exports